import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserEmployee } from './userEmployee';
import { UserEmployeeService } from './userEmployee.service';
import { NotificationService} from 'app/shared/notification/notification.service';
import { MatTableDataSource, PageEvent } from '@angular/material';
import { TableService } from 'app/core/models/pager';
import { UserEmployeeFilter } from './userEmployee.filter';
import { HttpParams } from '@angular/common/http';

@Component({
	template: `
		<h3 class="title" i18n="@@userEmployees">Employee Users</h3>

		<mat-accordion>
			<mat-expansion-panel [expanded]="isOpenSearchPanel" (opened)="openSearchPanel(true)" [hideToggle]="true">
				<mat-expansion-panel-header>
					<div *ngIf="tableService.filter" class="filter-panel-header fieldset-wrap">
						<div class="field-row">
							<div class="field-row-item" *ngIf="tableService.filter.email">
								<span class="label" i18n="@@email">Email</span>
								<span>{{tableService.filter.email}}</span>
							</div>
							<div class="field-row-item" *ngIf="tableService.filter.firstName">
								<span class="label" i18n="@@firstName">firstName</span>
								<span>{{tableService.filter.firstName}}</span>
							</div>
							<div class="field-row-item" *ngIf="tableService.filter.lastName">
								<span class="label" i18n="@@lastName">lastName</span>
								<span>{{tableService.filter.lastName}}</span>
							</div>
						</div>
					</div>
					<button class="btn-icon" i18n-title="@@option-search" title="Search" type="button">
						<i class="material-icons">search</i>
					</button>
				</mat-expansion-panel-header>

				<form>
					<fieldset class="fieldset">
						<div class="field-row">
							<div class="field-row-item">
								<label class="label" for="email" i18n="@@email">Email</label>
								<input type="text" name="email" placeholder="None" i18n-placeholder="None" [(ngModel)]="filter.email">
							</div>
						</div>
						<div class="field-row">
							<div class="field-row-item">
								<label class="label" for="firstName" i18n="@@firstName">First name</label>
								<input type="text" name="firstName" placeholder="None" i18n-placeholder="None" [(ngModel)]="filter.firstName">
							</div>
							<div class="field-row-item">
								<label class="label" for="lastName" i18n="@@lastName">Last name</label>
								<input type="text" name="lastName" placeholder="None" i18n-placeholder="None" [(ngModel)]="filter.lastName">
							</div>
						</div>
					</fieldset>
					<div class="options">
						<button class="btn-text gray" type="button" (click)="reset()">
							<span i18n="@@option-reset">Reset</span>
						</button>
						<button class="btn-text blue" type="button" (click)="search()">
							<span i18n="@@option-search">Search</span>
						</button>
					</div>
				</form>
			</mat-expansion-panel>
		</mat-accordion>

		<div class="tool-bar-wrap both-side">
			<div class="right row">
				<button class="btn-icon" i18n-title="@@option-create" type="button" (click)="create()" *hasPermission="['UserEmployees.create']">
					<i class="material-icons">add</i>
				</button>
				<ng-template [hasPermission]="['UserEmployees.delete']">
					<button class="btn-icon" i18n-title="@@option-delete" title="Delete" type="button" (click)="confirmDelete = false" *ngIf="tableService.selection.hasValue()">
						<i class="material-icons">delete</i>
					</button>
				</ng-template>
			</div>
		</div>

		<div class="mat-elevation-z8e" *ngIf="dataSource">
			<table mat-table [dataSource]="dataSource" matSort (matSortChange)="tableService.sortData($event); list();">
				<ng-container matColumnDef="select">
					<th mat-header-cell *matHeaderCellDef>
						<mat-checkbox (change)="tableService.masterToggle(dataSource.data)"
							[checked]="tableService.selection.hasValue() && tableService.isAllSelected(dataSource.data.length)"
							[indeterminate]="tableService.selection.hasValue() && !tableService.isAllSelected(dataSource.data.length)"
							*hasPermission="['UserEmployees.delete']">
						</mat-checkbox>
					</th>
					<td mat-cell *matCellDef="let row">
						<mat-checkbox (click)="$event.stopPropagation()"
							(change)="tableService.selection.toggle(row)"
							[checked]="tableService.selection.isSelected(row)"
							*hasPermission="['UserEmployees.delete']">
						</mat-checkbox>
					</td>
				</ng-container>

				<ng-container matColumnDef="email">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@email">Email</th>
					<td mat-cell *matCellDef="let element">{{element.authUser?.email}}</td>
				</ng-container>

				<ng-container matColumnDef="firstName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@firstName">First name</th>
					<td mat-cell *matCellDef="let element">{{element.firstName}}</td>
				</ng-container>

				<ng-container matColumnDef="lastName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@lastName">Last name</th>
					<td mat-cell *matCellDef="let element">{{element.lastName}}</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns;"
					(contextmenu)="tableService.selection.clear(); tableService.selection.select(row)" [contextMenu]="basicMenu" [contextMenuSubject]="row"
					(click)="read(row)">
				</tr>
			</table>

			<mat-paginator showFirstLastButtons
				[length]="tableService.pager.totalEntities"
				[pageIndex]="tableService.pager.pageIndex"
                [pageSize]="tableService.pager.pageSize"
				[pageSizeOptions]="[20, 50, 100]"
				(page)="list($event)">
			</mat-paginator>
		</div>

		<context-menu #basicMenu>
			<ng-template [hasPermission]="['UserEmployees.update']">
				<ng-template contextMenuItem (execute)="update($event.item)">
					<div class="item">
						<i class="material-icons">edit</i>
						<span i18n="@@option-update">Update</span>
					</div>
				</ng-template>
				<ng-template contextMenuItem (execute)="updatePassword($event.item)">
					<div class="item">
						<i class="material-icons">vpn_key</i>
						<span i18n="@@option-update-password">Update password</span>
					</div>
				</ng-template>
			</ng-template>

			<ng-template [hasPermission]="['UserEmployees.delete']">
				<ng-template contextMenuItem divider="true"></ng-template>
				<ng-template contextMenuItem (execute)="confirmDelete = false">
					<div class="item">
						<i class="material-icons">delete</i>
						<span i18n="@@option-delete">Delete</span>
					</div>
				</ng-template>
			</ng-template>
		</context-menu>

		<modal-ns [(closed)]="confirmDelete">
			<ng-template modalContentDirective>
				<div class="dialog-content">
					<div class="dialog-title" i18n="@@confirm">Confirmation</div>
					<div class="dialog-message" i18n="@@confirm-deletes">Are you sure you want to delete the selected items?</div>
					<div class="options">
						<button class="btn-text red" type="button" (click)="confirmDelete = true">
							<span i18n="@@option-no">No</span>
						</button>
						<button class="btn-text green" type="button" (click)="deletes(); confirmDelete = true">
							<span i18n="@@option-yes">Yes</span>
						</button>
					</div>
				</div>
			</ng-template>
		</modal-ns>
	`
})
export class UserEmployeeListComponent implements OnInit {
	dataSource: MatTableDataSource<UserEmployee>;
	displayedColumns: string[] = ['select', 'email', 'firstName', 'lastName'];
	confirmDelete = true;
	isOpenSearchPanel = false;
	filter = new UserEmployeeFilter(this.tableService.filter);

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private userEmployeeService: UserEmployeeService,
		public tableService: TableService<UserEmployee>,
		private notificationService: NotificationService,
	) {}

	ngOnInit() {
		this.list();
	}

	list(event?: PageEvent) {
		let httpParams = new HttpParams()
			.set('collection', 'id, firstName, lastName, authUser(id, email)')
			.set('pager.index', event ? event.pageIndex.toString() : this.tableService.pager.pageIndex.toString())
			.set('pager.size', event ? event.pageSize.toString() : this.tableService.pager.pageSize.toString());

		if (this.tableService.sort) { httpParams = httpParams.set('sort', this.tableService.sort) }

		httpParams = this.filter.getHttpParams(httpParams);

		this.userEmployeeService.getAll(httpParams).subscribe(data => {
			this.dataSource = new MatTableDataSource<UserEmployee>(data['result']);
			this.tableService.pager = data['pager'];
			this.tableService.selection.clear();
		});
	}

	create() {
		this.router.navigate(['./create'], {relativeTo: this.activatedRoute});
	}

	update(item: UserEmployee) {
		this.router.navigate(['./' + item.id + '/update'], {relativeTo: this.activatedRoute});
	}

	updatePassword(item: UserEmployee) {
		this.router.navigate(['./' + item.id + '/password'], {relativeTo: this.activatedRoute});
	}

	read(item: UserEmployee) {
		this.router.navigate(['./' + item.id], {relativeTo: this.activatedRoute});
	}

	deletes() {
		const length = this.tableService.selection.selected.length;
		this.tableService.pager.pageIndex = (this.tableService.pager.pageIndex > 0 && this.tableService.pager.totalEntitiesPerPage === length) ?
			--this.tableService.pager.pageIndex : this.tableService.pager.pageIndex;

		if (length === 1) {
			this.userEmployeeService.delete(this.tableService.selection.selected[0].id).subscribe(() => {
				this.notificationService.sucessDelete();
				this.list();
			}, err => this.notificationService.error(err));
		} else if (length > 1) {
			this.userEmployeeService.deletes(this.tableService.selection.selected).subscribe(() => {
				this.notificationService.sucessDelete();
				this.list();
			}, err => this.notificationService.error(err));
		}
	}

	reset() {
		this.filter = new UserEmployeeFilter();
	}

	search() {
		this.isOpenSearchPanel = false;
		this.tableService.pager.pageIndex = 0;
		this.tableService.filter = new UserEmployeeFilter(this.filter);
		this.list();
	}

	openSearchPanel(value: boolean) {
		this.isOpenSearchPanel = value;
		this.filter = new UserEmployeeFilter(this.tableService.filter);
	}
}
